import styled from 'styled-components';

export const WidgetWrapper = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  background: ${({ theme }) => theme.colors.white};
  width: 100%;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    width: 40%;
  }
`;

export const TitleWrapper = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
`;
